import React from 'react';

import ReportInfoModule from '../modules/ReportInfoModule.js';
import ReportTimelineTextModule from '../modules/ReportTimelineTextModule.js';
import AnalysisResultsModule from '../modules/AnalysisResultsModule.js';
import './Box.css';

const ReportPdfBox = ({user, reportId, isSmallScreen}) => {
    return (
        <div className={isSmallScreen ? "standard-box-screen-small" : "standard-box"}>
            {/* <h1 className='box-title'>Protocol Assessment</h1> */}
            <ReportInfoModule user={user} reportId={reportId} isSmallScreen={isSmallScreen}/>
            <ReportTimelineTextModule user={user} reportId={reportId} isSmallScreen={isSmallScreen}/>
            <AnalysisResultsModule user={user} reportId={reportId} isSmallScreen={isSmallScreen}/>
        </div>
    );
};

export default ReportPdfBox;
